// removed by extract-text-webpack-plugin
module.exports = {"slide-in-bottom":"_3OTaBclvrMmp30AG-kBTFe"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/global.scss
// module id = 795
// module chunks = 0